import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Injectable({
  providedIn: 'root'
})
export class MasterDepartmentService {

get baseUrl2(): string { return Constants.CORE_API_BASE_URL; }  
  constructor(private http: HttpClient) { }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl2 + 'Common/GetGroup', data);
  }
  getMasterDepartment(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.baseUrl + 'masterdepartmentbygroup', data);
    return this.http.post<any[]>(this.baseUrl2 + 'Master/GetMasterDepartmentsByEgId', data);
    
  }
 
  addSubDepartment(data: any): Observable<any>{
    return this.http.post<any>(this.baseUrl2 + "Department/addSubDepartment", data);
  }

  getSubDepartment(data: any): Observable<any>{
    return this.http.post<any>(this.baseUrl2 + "Department/getSubDepartment", data);
  }

  editSubDepartment(data: any): Observable<any>{
    return this.http.post<any>(this.baseUrl2 + "Department/editSubDepartment", data);
  }

  deleteSubDepartment(data: any): Observable<any>{
    return this.http.post<any>(this.baseUrl2 + "Department/deleteSubDepartment", data);
  }

  getSubDepartmentByDeptId(data: any): Observable<any>{
    return this.http.post<any>(this.baseUrl2 + "Department_Lean/getSubDepartmentByDeptId", data);
  }
 
  //NOT IN USE
  // getAllDepartmentList(): Observable<any[]> {
  //   return this.http.get<any[]>(this.baseUrl + 'allmasterdepartments');
  // }
  addDepartment(data: any)  {
    //return this.http.post<any[]>(this.baseUrl + 'addmasterdepartment', data);
  }

  //NOT IN USE
  // getAllDepartmentList(): Observable<any[]> {
  //   return this.http.get<any[]>(this.baseUrl + 'allmasterdepartments');
  // }

  updateDepartment(data: any)  {
    //return this.http.put<any[]>(this.baseUrl + 'masterdepartment', data);
  }

  deleteDepartment(data: any) {
    //return this.http.post<any>(this.baseUrl + 'deletemasterdepartment', data);
  }

  GetOneMasterDepartment(data: any) {
    //return this.http.post<any>(this.baseUrl + 'onemasterdepartment', data);
  }
  // hardCodeToken: string = environment.token;
  // constructor(private http: HttpClient) { }

  // getMasterDepartment(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.baseUrl + 'masterdepartmentbygroup', data);
  // }
}
